const verificacoesCampanha = [
  {
    action: "acompanhamentoMensal/verificarPendenciaCampanha",
    clearAction: "acompanhamentoMensal/clearCampanhaPendencia"
  }
];

function executarVerificacoes(store) {
  setTimeout(() => {
    verificacoesCampanha.forEach(({ action }) => {
      store.dispatch(action, { force: true }).catch(() => {});
    });
  }, 0);
}

function limparVerificacoes(store) {
  verificacoesCampanha.forEach(({ clearAction }) => {
    store.dispatch(clearAction).catch(() => {});
  });
}

export default function campanhaPendenciaPlugin(store) {
  store.subscribe(mutation => {
    if (mutation.type === "DEFINIR_USUARIO_LOGADO") {
      executarVerificacoes(store);
    }

    if (mutation.type === "DESLOGAR_USUARIO") {
      limparVerificacoes(store);
    }
  });
}
